import React from 'react';
import { Box, Typography, Grid, Card } from '@mui/material';

/**
 * KeyStatistics Component
 * 
 * Displays key statistics with visual elements
 * 
 * @param {Object} props
 * @param {Array} props.stats - Array of statistic text strings to display
 * @param {Array} props.highlights - Array of highlight objects: { value: "25%", description: "of adults 65+ fall each year" }
 */
const KeyStatistics = ({ stats, highlights }) => {
  return (
    <Box>
      <Typography 
        variant="h5" 
        gutterBottom 
        sx={{ 
          color: 'primary.main', 
          fontWeight: 600,
          mb: 3 
        }}
      >
        Key Statistics
      </Typography>
      <Grid container spacing={4}>
        {/* Left side - Statistics list */}
        <Grid item xs={12} md={7}>
          <Card elevation={0} sx={{ 
            p: 3,
            bgcolor: 'background.paper',
            borderRadius: 2,
            borderLeft: '4px solid',
            borderColor: 'primary.main'
          }}>
            {stats?.map((stat, index) => (
              <Box 
                key={index} 
                sx={{ 
                  display: 'flex',
                  alignItems: 'flex-start',
                  mb: index < stats.length - 1 ? 2.5 : 0
                }}
              >
                <Box 
                  sx={{ 
                    width: 8,
                    height: 8,
                    borderRadius: '50%',
                    bgcolor: 'primary.main',
                    mt: 1.2,
                    mr: 2,
                    flexShrink: 0
                  }} 
                />
                <Typography 
                  variant="body1" 
                  sx={{ 
                    color: 'text.primary',
                    lineHeight: 1.6,
                    fontSize: '1.1rem'
                  }}
                >
                  {stat}
                </Typography>
              </Box>
            ))}
          </Card>
        </Grid>

        {/* Right side - Highlight cards */}
        <Grid item xs={12} md={5}>
          <Grid container spacing={2}>
            {highlights?.map((highlight, index) => (
              <Grid item xs={12} key={index}>
                <Card 
                  elevation={1} 
                  sx={{ 
                    p: 3,
                    bgcolor: 'primary.main',
                    color: 'white',
                    borderRadius: 2,
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-2px)',
                      boxShadow: 3
                    }
                  }}
                >
                  <Typography 
                    variant="h3" 
                    sx={{ 
                      fontWeight: 700,
                      mb: 1,
                      letterSpacing: '-0.02em'
                    }}
                  >
                    {highlight.value}
                  </Typography>
                  <Typography 
                    variant="body1" 
                    sx={{ 
                      opacity: 0.9,
                      fontWeight: 500
                    }}
                  >
                    {highlight.description}
                  </Typography>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default KeyStatistics; 